// Unified notifications. antd's static `notification.*`/`message.*` don't render
// reliably under React 19 — we use the App-context instances instead. A top-level
// <NotifyBridge/> (rendered inside antd <App>) registers the instances here so any
// module (not just components) can call notify.* .
let napi = null; // antd notification instance
let mapi = null; // antd message instance

export const registerNotify = (notification, message) => {
  napi = notification;
  mapi = message;
};

const fallback = (level, content) =>
  // eslint-disable-next-line no-console
  console[level === "error" ? "error" : "log"](`[notify:${level}]`, content);

export const notify = {
  success: (msg, description) =>
    napi ? napi.success({ message: msg, description }) : fallback("info", msg),
  error: (msg, description) =>
    napi ? napi.error({ message: msg, description }) : fallback("error", msg),
  info: (msg, description) =>
    napi ? napi.info({ message: msg, description }) : fallback("info", msg),
  warning: (msg, description) =>
    napi ? napi.warning({ message: msg, description }) : fallback("info", msg),
  // toast-style transient
  toast: (msg) => (mapi ? mapi.success(msg) : fallback("info", msg)),
};

// Pull a server error message out of an Axios error, with a fallback.
export const serverError = (error, fallbackMsg = "Something went wrong") =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  fallbackMsg;
